import React from 'react';
import { Section } from '../components/Section';
import { StartHere } from '../components/StartHere';
import { asset } from '../data/redesignAssets';
import { TEAM } from '../data/team';
export function About() {
  return <>
      <Section n="01" label="About" noTop contentClassName="page-hero" data-id="element-289" data-mp="29l6pp8bd7jge">
        <h1 className="h1" style={{
        maxWidth: 760
      }} data-id="element-290" data-mp="2ehx65wr30h2c">
          We build the part of AI
          <br className="d" data-id="element-291" data-mp="327rhuaznzzl0" /> nobody was governing.
        </h1>
        <p className="lede" style={{
        maxWidth: 800
      }} data-id="element-292" data-mp="32682qnpqvukt">
          Every enterprise AI stack has a shelf for knowledge: <em data-id="element-293" data-mp="3751bk2u36xen">graphs, semantic search, vector stores</em>.{' '}
          <strong data-id="element-294" data-mp="2s9lf5r61apf3">None of them has a shelf for the obligations that must be in the prompt before the model generates a single token.</strong>{' '}
          So whether the must-have rules make it into the prompt depends on who’s typing. Synthia exists to close that gap: to make the
          instructions complete, to get them in before the model’s attention is spent, and to end the rework tax that starts the moment
          your AI gets instructions that are missing context.
        </p>
      </Section>

      <section className="bleed sec-dk does" data-id="element-295" data-mp="1pkjkgw0cmd7g">
        <div className="sec" style={{
        borderTop: 0
      }} data-id="element-296" data-mp="23i83dyauva9v">
          <div className="sec-m" data-id="element-297" data-mp="23jrny13jo7hg">
            <div className="sec-n" data-id="element-298" data-mp="1yjn5i5j2t2ol">02</div>
            <div className="sec-l" data-id="element-299" data-mp="1yilv839vwk7x">Why</div>
          </div>
          <div className="why-c" data-id="element-300" data-mp="2dge7mmk4wshw">
            <p className="why" data-id="element-301" data-mp="2dfcu8bfnbtx0">
              The fifth time we saw the same correction, we stopped calling it a correction. It was a missing obligation, and the model
              kept committing us without it.
              <br data-id="element-302" data-mp="2m8g6igek20q2" />
              <span style={{
              color: 'var(--mint)'
            }} data-id="element-303" data-mp="2mb2egh5cyi8t">So we automated the obligations.</span>
            </p>
          </div>
        </div>
      </section>

      <Section n="03" label="The people" data-id="element-304" data-mp="2w8708fvakbp3">
        <h2 className="h2" data-id="element-305" data-mp="2w51bx2uhlduf">Humans in the loop.</h2>
        <div className="team" data-id="element-306" data-mp="2r8u4f5mfzuad">
          {TEAM.map(p => <div className="person" key={p.name} data-id="element-307" data-mp="1oumr9z64luo8">
              <img src={asset(p.photo)} alt={p.name} loading="lazy" data-id="element-308" data-mp="1ovxtvvnu4wdr" />
              <div className="id" data-id="element-309" data-mp="1svq5kh8izinc">
                <div className="nm" data-id="element-310" data-mp="1swrikr93qf7p">{p.name}</div>
                <div className="rl" data-id="element-311" data-mp="1xvkx8n04kc9g">{p.role}</div>
              </div>
              <div className="bio" data-id="element-312" data-mp="1xt86bkce2rk9">{p.bio}</div>
            </div>)}
        </div>
      </Section>

      <StartHere n="04" data-id="element-313" data-mp="22o47pb3imra1" />
    </>;
}